import { List, ListItem, ListItemText, ListItemIcon, IconButton, Icon } from '@material-ui/core';
import AttachFileIcon from "@material-ui/icons/AttachFile";
import React, { Component } from 'react';
import ActionsContextV2 from '../ActionsContextV2';
import styled from 'styled-components';
import DeleteIcon from "@material-ui/icons/DeleteOutline";

const ListItemTextContent = styled.div`
  display:flex;
  align-items:center;
  justify-content:space-between;
  width:100%;
`;

const FileButtonContainer = styled.div`
display:flex;
align-items:center;
justify-content:flex-start;
`


const DeleteButtonContainer = styled.div`
    padding-left:5px;
`

class ActionDeviationFilesV2 extends Component {

  static contextType = ActionsContextV2;

  renderListItem = (file, index) => (
    <ListItem key={index}>
      <ListItemTextContent>
        <FileButtonContainer>

          <AttachFileIcon />
          {file.name}

        </FileButtonContainer>
        <DeleteButtonContainer>
          <IconButton onClick={() => this.context.updateDeviationFileDeletedIndex(index)}>
            <DeleteIcon />
          </IconButton>
        </DeleteButtonContainer>
      </ListItemTextContent>

    </ListItem>
  )

  render() {

    const { deviationFileUploads, deviationFileUploadsDeletedIndexes } = this.context;

    return (
      <List>
        {deviationFileUploads && deviationFileUploads.map((file, index) => (!deviationFileUploadsDeletedIndexes[index] ?
          this.renderListItem(file, index) : null



        ))}
        {this.props.attachments && this.props.attachments.map((attachment, index) => attachment.isDeleted ? null :
          <ListItem key={index}>
            <ListItemTextContent>
              <FileButtonContainer>
                <AttachFileIcon />
                <div>
                  <a href={`/api/attachments/download/${attachment.id}`}>{attachment.virtualPath}</a>
                </div>
              </FileButtonContainer>
              <DeleteButtonContainer>
                <IconButton onClick={() => this.props.onDeleteAttachment(index)}>
                  <DeleteIcon />
                </IconButton>
              </DeleteButtonContainer>
            </ListItemTextContent>

          </ListItem>

        )}
      </List>

    )
  }
}

export default ActionDeviationFilesV2;